<template>
  <div class="pc-search__result-item">
    <div class="pc-search__result-name">
      <icon-book v-if="isNotebook" class="static type-icon"/>
      <icon-file-alt v-if="isNote" class="static type-icon"/>
      <a v-html="data.name" @click="goHandler"></a>
    </div>
    <div v-if="isNotebookNote" class="pc-search__result-notebook-name">
      <div>笔记本: <a @click="goNotebookHandler">{{data.data.notebookName}}</a></div>
    </div>
    <div class="pc-search__result-tags" v-if="tag" v-html="tag"></div>
    <div class="pc-search__result-contents" v-if="content">
      <div class="pc-search__result-content" v-html="content"></div>
    </div>
    <div class="pc-search__result-time">
      <div>最近更新: {{data.modifiedTime | datetime}}</div>
      <!-- <div>创建: {{data.createdTime}}</div> -->
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import IconBook from '@/components/icon/Book.vue'
import IconFileAlt from '@/components/icon/FileAlt.vue'
import { mapMutations } from 'vuex'

const repairHighlightRegex = /&lt;span(?:&nbsp;)*class=&quot;pc-shl&quot;&gt;(.+?)(?=&lt;\/span&gt;)&lt;\/span&gt;/gi

export default {
  name: 'SearchResultItem',
  props: ['data'],
  components: {
    IconBook,
    IconFileAlt
  },
  data () {
    return {}
  },
  computed: {
    content () {
      const contents = this.data.content
      if (contents) {
        return _.map(contents, content => {
          // return `<div class="pc-search__result-content">${content}</div>`
          const escaped = _.escape(content)
          return escaped
            .replace(/\n+/gi, '<br/>')
            .replace(/\s/g, '&nbsp;')
            .replace(repairHighlightRegex, '<span class="pc-shl">$1</span>')
        }).join('')
      }
      return ''
    },
    tag () {
      const tagNames = this.data.tagNames
      if (tagNames && tagNames.length && tagNames.length > 0) {
        return _.map(tagNames, tagName => {
          return `<div class="pc-search__result-tag">${tagName}</div>`
        }).join('')
      }
      return ''
    },
    isNotebook () {
      return this.data.resourceType === 1
    },
    isNote () {
      return this.data.resourceType === 0
    },
    isNotebookNote () {
      return this.data.data && this.data.data.notebookId
    }
  },
  methods: {
    ...mapMutations('search', {
      setVisible: 'SET_VISIBLE'
    }),
    goHandler () {
      if (this.isNotebook) {
        this.$router.push({
          name: 'workbenchNotebook',
          params: {
            notebookId: this.data.resourceId
          }
        })
      } else if (this.isNotebookNote) {
        this.$router.push({
          name: 'workbenchNotebookNote',
          params: {
            noteId: this.data.resourceId,
            notebookId: this.data.data.notebookId
          }
        })
      } else {
        this.$router.push({
          name: 'workbenchNote',
          params: {
            noteId: this.data.resourceId
          }
        })
      }
      this.setVisible(false)
    },
    goNotebookHandler () {
      this.$router.push({
        name: 'workbenchNotebook',
        params: {
          notebookId: this.data.data.notebookId
        }
      })
      this.setVisible(false)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-search__result-item {
  padding: 1rem 0 2rem 0;
  word-wrap: break-word;
  border: 1px solid $border-color-structure;
  padding: 1rem;
  border-radius: .5rem;
  margin-top: 1rem;
  transition: border-color .15s linear;

  &:hover {
    border-color: $color-main;
  }

  .pc-shl {
    color: red;
  }
}
.pc-search__result-name, .pc-search__result-notebook-name {
  font-size: 1.6rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #1468c2;

  .type-icon {
    margin-right: .5rem;
    font-size: 1.4rem;
  }

  a:hover {
    text-decoration: underline;
    text-decoration-thickness: 2px;
    cursor: pointer;
  }
}
.pc-search__result-notebook-name {
  font-size: 1.2rem;
  color: $color-b3;
  margin-top: .5rem;
}
.pc-search__result-content {
  font-size: 1.4rem;
  margin-top: 1rem;
}
.pc-search__result-time {
  margin-top: 1rem;
  color: $color-b3;
  span {
    margin-right: 2rem;
  }
}
.pc-search__result-tags {
  display: flex;
  flex-direction: row;
}
.pc-search__result-tag {
  padding: .2rem .5rem;
  margin: 1rem 1rem 0 0;
  background-color: #ecf5ff;
  border: 1px solid #d9ecff;
  border-radius: .4rem;
  color: #409EFF;
}

</style>
